import {RequestExecption} from "../store/types/general";

export const convertToJson = (response: Response) =>
    response.text()
        .then((res) => {
            try {
                return JSON.parse(res);
            } catch (err) {
                throw new RequestException("Det har uppstått ett tekniskt problem. Om problemet kvarstår, kontakta kundtjänst.");
            }
        });

export const isResponseOk = async (response: Response) => {
    if (response.status === 200) {
        return response;
    } else {
        throw new RequestException("Det har uppstått ett tekniskt problem. Om problemet kvarstår, kontakta kundtjänst.");
    }
}

const RequestException = function (this: RequestExecption, message: string) {
    this.name = 'RequestException';
    this.message = message;
} as any as { new(message: string): RequestExecption; };
